var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import media, { SCREEN_WIDTH } from '../../utils/media';
import { isLeftAligned } from '../../utils/variations';
import { Image } from '../Image';
import { OnScrollWrapper } from '../UtilityWrappers';
import { Transition } from '../ComponentWrappers';
import { isFieldValid } from '../../utils/validation';
import { isExperienceEditor } from '../../utils/experience-editor';
const ImageContainer = styled.div `
  width: calc(50% - 165px);
  position: relative;
  display: flex;
  ${({ alignment }) => isLeftAligned(alignment)
    ? css `
          justify-content: flex-end;
          margin: 0px 165px 0px 0px;

          ${media.tablet} {
            margin: 0px 13px 0px 0px;
            width: calc(50% - 13px);
          }
        `
    : css `
          justify-content: flex-start;
          margin: 0px 0px 0px 165px;
          ${media.tablet} {
            margin: 0px 0px 0px 35px;
            width: calc(50% - 35px);
          }
        `}

  ${media.mobile} {
    max-width: 320px;
    max-height: 330px;
    justify-content: center;
    margin: 0 auto 24px;
    padding: 0;
    width: 100%;
  }
`;
const StyledImage = styled((_a) => {
    var { isMobile } = _a, others = __rest(_a, ["isMobile"]);
    return React.createElement(Image, Object.assign({}, others));
}) `
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;

  ${({ isMobile }) => isMobile &&
    css `
      display: none;
      ${media.mobile} {
        display: block;
      }
    `}
`;
const ForegroundImageContainer = styled.div `
  margin: 0;
  display: block;
  ${({ alignment }) => isLeftAligned(alignment)
    ? css `
          position: absolute;
          bottom: 0;
          right: 0;
        `
    : css `
          position: absolute;
          bottom: 0;
          left: 0;
        `}

  width: 100%;
  max-width: 540px;

  ${media.mobile} {
    height: 100%;
  }
`;
const BackgroundImageContainer = styled.div `
  margin: 0;
  display: block;
  position: absolute;
  width: 100%;
  max-width: 540px;
  ${({ alignment }) => isLeftAligned(alignment)
    ? css `
          position: absolute;
          bottom: 0;
          right: 0;
        `
    : css `
          position: absolute;
          bottom: 0;
          left: 0;
        `}

  ${media.mobile} {
    display: none;
  }
`;
const BackgroundImagePlacholder = styled(BackgroundImageContainer) `
  opacity: 0;
  position: relative;
  ${media.mobile} {
    opacity: 1;
    display: block;
  }
`;
export const AnimatedImageContainer = ({ desktopBackgroundImage, mobileBackgroundImage, desktopForegroundImage, mobileForegroundImage, alignment, }) => {
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    if (typeof window === 'undefined') {
        return null;
    }
    else {
        const renderForegroundImageContent = isFieldValid(desktopForegroundImage, 'src') && isFieldValid(mobileForegroundImage, 'src');
        const useMobileLayout = window.screen && window.screen.width <= SCREEN_WIDTH.MOBILE;
        const renderContentAsExperienceEditor = (React.createElement(ImageContainer, { alignment: alignment },
            React.createElement(BackgroundImagePlacholder, null, useMobileLayout ? (React.createElement(StyledImage, { media: mobileBackgroundImage })) : (React.createElement(StyledImage, { media: desktopBackgroundImage }))),
            React.createElement(BackgroundImageContainer, { alignment: alignment },
                React.createElement(StyledImage, { media: desktopBackgroundImage })),
            renderForegroundImageContent && (React.createElement(ForegroundImageContainer, { alignment: alignment }, useMobileLayout ? (React.createElement(StyledImage, { media: mobileForegroundImage })) : (React.createElement(StyledImage, { media: desktopForegroundImage }))))));
        if (isExperienceEditor()) {
            return renderContentAsExperienceEditor;
        }
        else {
            return (React.createElement(OnScrollWrapper, { onVisibilityChange: setIsComponentVisible, isPartiallyVisible: true },
                React.createElement(ImageContainer, { alignment: alignment },
                    React.createElement(React.Fragment, null,
                        React.createElement(BackgroundImagePlacholder, null, useMobileLayout ? (React.createElement(StyledImage, { media: mobileBackgroundImage })) : (React.createElement(StyledImage, { media: desktopBackgroundImage }))),
                        isComponentVisible && (React.createElement(BackgroundImageContainer, { alignment: alignment },
                            React.createElement(Transition, { initiateTransition: isComponentVisible, transitionType: isLeftAligned(alignment) ? 'slideInRight' : 'slideInLeft' },
                                React.createElement(StyledImage, { media: desktopBackgroundImage }))))),
                    renderForegroundImageContent && isComponentVisible && (React.createElement(ForegroundImageContainer, { alignment: alignment },
                        React.createElement(Transition, { delay: 1800, initiateTransition: isComponentVisible, transitionType: useMobileLayout
                                ? 'slideInRight'
                                : isLeftAligned(alignment)
                                    ? 'slideInRight'
                                    : 'slideInLeft' }, useMobileLayout ? (React.createElement(StyledImage, { media: mobileForegroundImage })) : (React.createElement(StyledImage, { media: desktopForegroundImage }))))))));
        }
    }
};
